(function () {
    'use strict';

    angular
        .module('telestatApp')
        .directive('capitalizeFirst', ['$parse',  function($parse) {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, modelCtrl) {
                    var capitalize = function(inputValue) {
                        if (!inputValue) {
                            inputValue = '';
                        } else {
                            inputValue = inputValue.trim();
                        }
                        var capitalized = inputValue.charAt(0).toUpperCase() + inputValue.substring(1);
                        if(capitalized !== inputValue) {
                            // store current edit position
                            var start = element[0].selectionStart, end = element[0].selectionEnd;
                            modelCtrl.$setViewValue(capitalized);
                            modelCtrl.$render();
                            // restore current edit position
                            element[0].setSelectionRange(start, end);
                        }
                        return capitalized;
                    };
                    modelCtrl.$parsers.push(capitalize);
                    capitalize($parse(attrs.ngModel)(scope)); // capitalize initial value
                }
            };
         }])
         .directive('capitalizeFully', ['$parse',  function($parse) {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, modelCtrl) {
                    var capitalize = function(inputValue) {
                        if (!inputValue) {
                            inputValue = '';
                        } else {
                            inputValue = inputValue.trim();
                        }

                        function isDelimiter(ch, delimiters) {
                            if (delimiters == null) {
                                return false;
                            }
                            for (var i = 0, isize = delimiters.length; i < isize; i++) {
                                if (ch == delimiters[i]) {
                                    return true;
                                }
                            }
                            return false;
                        }
                        function capitalize(str, delimiters) {
                            var delimLen = (delimiters == null ? -1 : delimiters.length);
                            if (!str || delimLen == 0) {
                                return str;
                            }
                            var strLen = str.length;
                            var buffer = "";
                            var capitalizeNext = true;
                            for (var i = 0; i < strLen; i++) {
                                var ch = str.charAt(i);
                                if (isDelimiter(ch, delimiters)) {
                                    buffer += ch;
                                    capitalizeNext = true;
                                } else if (capitalizeNext) {
                                    buffer += ch.toUpperCase();
                                    capitalizeNext = false;
                                } else {
                                    buffer += ch.toLowerCase();
                                }
                            }
                            return buffer;
                        }

                        var delimiters = [' ', "\n", "\t", "\r", '-'];
                        var capitalized = capitalize(inputValue, delimiters);
                        if(capitalized !== inputValue) {
                            // store current edit position
                            var start = element[0].selectionStart, end = element[0].selectionEnd;
                            modelCtrl.$setViewValue(capitalized);
                            modelCtrl.$render();
                            // restore current edit position
                            element[0].setSelectionRange(start, end);
                        }
                        return capitalized;
                    };
                    modelCtrl.$parsers.push(capitalize);
                    capitalize($parse(attrs.ngModel)(scope)); // capitalize initial value
                }
            };
         }]);
})();


